// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"42f5bd43","774":"279fe7f8"}[chunkId] + ".chunk.js";
};